import { Component, Input, OnInit } from "@angular/core";
import { DataService_NotifyRegBatch } from "../shared/data.service";
import * as moment from "moment";

@Component({
	selector: "caass-guardian-notify-email-log",
	templateUrl: "./guardian-notify-email-log.component.html",
	styleUrls: ["./guardian-notify-email-log.component.css"],
})
export class GuardianNotifyEmailLogComponent implements OnInit {
	constructor(private GuardianNotifyService: DataService_NotifyRegBatch) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.loadGuardianNotifyEmailLog();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	StartDate: Date = new Date();
	EndDate: Date = new Date();

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedGuardianNotifyEmailLog: any;
	lstGuardianNotifyEmailLog: any = [];

	//Filter lists
	lstSuccessfulDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "StudentID", header: "Student ID" },
		{ field: "StudentName", header: "Student" },
		{ field: "GuardianName", header: "Parent" },
		{ field: "GuardianEmail", header: "Parent Email" },
		// { field: 'RegistrationNbr', header: 'Registration Key' },
		// { field: 'RegistrationExpireDTDesc', header: 'Key Expires' },
		// { field: 'c_dateDesc', header: 'Sent Time' },
		// { field: 'AdminPersonName', header: 'Sent By' },
		// { field: 'SuccessfulDesc', header: 'Successful' },
	];

	cols2: any = [
		//INSERT CUSTOM COLUMNS HERE
		// { field: 'StudentID', header: 'Student ID' },
		// { field: 'GuardianName', header: 'Parent' },
		// { field: 'GuardianEmail', header: 'Parent Email' },
		// { field: 'RegistrationNbr', header: 'Registration Key' },
		// { field: 'RegistrationExpireDTDesc', header: 'Key Expires' },
		{ field: "c_dateDesc", header: "Sent Time" },
		{ field: "AdminPersonName", header: "Sent By" },
		// { field: 'SuccessfulDesc', header: 'Successful' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadGuardianNotifyEmailLog() {
		this.loading = true;

		//Format dates
		var fsDate = moment(this.StartDate).format("MM/DD/YYYY");
		var feDate = moment(this.EndDate).format("MM/DD/YYYY");

		if (String(fsDate).toLowerCase().indexOf("invalid") != -1 || String(feDate).toLowerCase().indexOf("invalid") != -1) {
			this.loading = false;
			return;
		}

		var result = this.GuardianNotifyService.EmailLogInfoSelectList(fsDate, feDate);
		result.subscribe(
			(response) => {
				this.lstGuardianNotifyEmailLog = response;

				//Load Data Filter Lists
				this.lstSuccessfulDesc = Array.from(new Set(this.lstGuardianNotifyEmailLog.map((item: any) => item.SuccessfulDesc)));

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadGuardianNotifyEmailLog();
	}

	//Custom Button Methods

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedGuardianNotifyEmailLog = val.data;
	}
	onRowUnselect(val) {
		this.SelectedGuardianNotifyEmailLog = null;
	}
	onRowDblClick(GuardianNotifyEmailLog) {
		this.SelectedGuardianNotifyEmailLog = GuardianNotifyEmailLog;
		// this.onEditGuardianNotifyEmailLog();
	}

	onStartDateChange(val) {
		this.StartDate = val;

		this.loadGuardianNotifyEmailLog();
	}

	onEndDateChange(val) {
		this.EndDate = val;

		this.loadGuardianNotifyEmailLog();
	}

	////////////////////////////////////////////
}
